module.exports = __webpack_public_path__ + "img/area_24.aff33cab.svg";